const KNOWN_ACRONYMS = new Set([
  'XSS',
  'CSRF',
  'SSRF',
  'SQL',
  'API',
  'CVE',
  'IDOR',
  'LDAP',
  'SSTI',
  'XXE',
  'HTTP',
  'DOM',
  'CSV',
  'JWT',
  'BOLA',
  'BOPLA',
  'BFLA',
  'XPATH',
  'ACL',
  'ADCS',
  'AI',
  'DNS',
  'GPO',
  'SMB',
  'TLS',
  'RCE',
  'LFI',
  'RFI',
]);

export function formatWordWithKnownAcronyms(word: string): string {
  const upperWord = word.toUpperCase();
  if (KNOWN_ACRONYMS.has(upperWord)) {
    return upperWord;
  }
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

export function formatCategoryForDisplay(category?: string | null): string {
  if (!category) {
    return '';
  }

  return category
    .split('_')
    .filter((part) => part.length > 0)
    .map(formatWordWithKnownAcronyms)
    .join(' ');
}
